import { useState } from 'react';


export default function useMobileFilterToggle() {

  const [mustShowFilters, setMustShowFilters] = useState(false);

  function toggleFilters() {
    setMustShowFilters(previous => !previous );

  }

  function showFilters() {
    setMustShowFilters(true);
  }

  function hideFilters() {
    setMustShowFilters(false);
  }

  function areFiltersShown() {
    return mustShowFilters === true;
  }

  return { toggleFilters, showFilters, hideFilters, areFiltersShown }
}
